export const handleClickAway = (event, anchor, callback) => {
  if (anchor !== event.target && !anchor.contains(event.target)) {
    callback();
  }
  return null;
};

export default handleClickAway;
